import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const StyledIframe = styled.iframe`
  max-width: 100%;
  border: 0;
`;